import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import ServiceGrid from "../components/ServiceGrid"
import Address from "../components/Address"
import AboutServices from "../components/AboutServices"
import Banner from "../components/Banner"

const IndexPage = () => {
  return (
    <Layout>
      <SEO
       title="Advogados Especialistas em Direito Criminal"
       lang="en"
       description="Escritório de Advocacia Especializada em Direito Criminal.Lei Maria da Penha.Habeas Corpus.Garanta seus Direitos!Advogado Criminal em Goiânia-Go"
      />
      <Banner />
      <ServiceGrid />
      <AboutServices />
      <Address />
    </Layout>
  )
}

export default IndexPage
